import React from "react";
import { Grid, Typography } from "@material-ui/core";
import DPBackArrow from "Components/DP/DPBackArrow/DPBackArrow";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import useStyles from "./styles";

type Props = {
  title: string;
};

export const AnomalyReportHeader = ({
  title,
}: Props) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.container}>
      <Grid item>
        <DPBackArrow to={InternalRoutes.netEarnings} />
      </Grid>
      <Grid item>
        <Typography className={classes.name} variant="h1">
          {title}
        </Typography>
      </Grid>
    </Grid>
  );
};
